// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"77dc2e86","455":"1d415b8b"}[chunkId] + ".chunk.js";
};